<template>
    <div id="profile-page">
        <div class="page-heading">
            <h2 class="display-4 montserrat-bold mb-0">Bookings</h2>
            <div class="mt--2 heading-small">Booking Transactions History</div>
        </div>
    
        <!-- <div class="search-bar-container">
            <i class="fas fa-search icon"></i>
            <input type="text" placeholder="Search" class="search-bar">
        </div> -->

        <div class="bg-white shadow-reg list-container">
            <div class="table-navbar">
                <a :class="['table-navbar-item', isStatusActive('all') && 'active']" href="/all" @click.prevent="setStatusFilter('all')">All</a>
                <a :class="['table-navbar-item', isStatusActive('new_booking') && 'active']" href="/new_booking" @click.prevent="setStatusFilter('new_booking')">New Booking</a>
                <a :class="['table-navbar-item', isStatusActive('cancelled') && 'active']" href="/cancelled" @click.prevent="setStatusFilter('cancelled')">Cancelled</a>
                <a :class="['table-navbar-item', isStatusActive('expired_booking') && 'active']" href="/expired_booking" @click.prevent="setStatusFilter('expired_booking')">Expired</a>
                <a :class="['table-navbar-item', isStatusActive('done') && 'active']" href="/done" @click.prevent="setStatusFilter('done')">Completed</a>
            </div>
            <div class="list-wrapper">
                <paginated-section :fetch-link="bookingFetchLink" :params="bookingParams" paginate-path="data.result.bookings" ref="list" simplified>
                    <template slot="loading">
                        <h3 class="text-muted m-0 pt-5 pb-5 text-center">
                            <i class="fas fa-spin fa-spinner mr-2"></i> Loading bookings
                        </h3>
                    </template>
                    <template slot="empty">
                        <h3 class="text-muted m-0 pt-5 pb-5 text-center">No bookings were found</h3>
                    </template>
                    <template slot="body" slot-scope="{ record }">
                        <booking-list-item :booking="record" />
                    </template>

                </paginated-section>
            </div>
        </div>

    </div>
</template> 
<script>
import '@styles/table.css';
import BookingListItem from "./BookingListItem";
import { route, get } from "@utils/network";

export default {
    name: "BookingListPage",

    components: { BookingListItem },

    computed: {
        bookingFetchLink() {
            return route("bookings");
        },
    },

    data: () => ({
        loading: false,
        bookings: [],
        
        bookingParams: {
            status: "all",
        }
    }),

    methods: {
        setStatusFilter(status) {
            this.bookingParams.status = status;
            this.$refs.list.refresh();
        },
        isStatusActive(status) {
            return this.bookingParams.status == status;
        },
    },

    mounted() {
        this.$emit("mounted");
    }
}
</script>